import React from "react";
import "./index.css";

/* These are the components used in the Home page */
/* To edit a specific component, find it under the components folder*/
import Carousel from "../../components/Carousel";
import SupportedGames from "../../components/SupportedGames";
import LatestNews from "../../components/LatestNews";
import Events from "../../components/Events";
import Stats from "../../components/Stats";


/*
  Carousel is the rotating banner image at the top of the Home page.
  Supported Games is the top 4 games supported listed right under the Carousel.
  Latest News is the component showing a small news piece in the middle of the Home page.
  Finally, side-by-side, we have the Events list component and Stats component.
  There isn't much to edit here, though I suppose you can change the order, if you want.
*/
const Home = () => {
  return (
    <div className="home-page">
      <Carousel />
      <SupportedGames />
      <LatestNews />
      <div className="row">
        <Events />
        <Stats />
      </div>
    </div>
  );
};

export default Home;
